import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import Layout from "../../../components/layout/Layout";
import CommonNavigator from "../../../components/common/CommonNavigator";
import { CustomAdminLayout } from "../../../components/layout/CustomAdminLayout";
import CustomDrawer from "../../../components/layout/CustomDrawer";
import FilterPanel from "../../../components/filters/FilterPanel";
import PaginatedDataTable from "../../../components/table/PaginatedDataTable";
import { useGetClientFinancialsQuery } from "../../../redux/service/modules/sales";
import TrendButton from "../../../components/table/TrendButton";
import CorporateAccessTooltip from "../../../components/table/CorporateAccessTooltip";
import ValueBox from "../../../components/table/ValueBox";
import CustomCurrencyFormat from "../../../components/common/CurrencyFormatter";
import WholeNumberFormatter from "../../../components/common/WholeNumberFormatter";

const SalesDashboard = () => {
    const [isFilterOpen, toggleFilter] = useState(false);
    const dateRange = useSelector((state) => state.date);
    const [requiredFilters, setRequiredFilters] = useState([]);
    const [filterDetails, setFilterDetails] = useState({
        appliedFilters: {
            isClient: "Client",
        },
        filterCount: 0,
        rawFilters: {},
        searchText: "",
    });
    const [filters, setFilters] = useState([]);

    // useEffect(() => {
    //     if (dateRange) {
    //         setFilterDetails({
    //             ...filterDetails,
    //             appliedFilters: { initialDateRange: dateRange },
    //         });
    //     }
    // }, [dateRange]);
    const finalFilters = useMemo(
        () => ({
            appliedFilters: {
                isClient: "Client",
                ...filterDetails.appliedFilters,
                ...(dateRange ? { initialDateRange: dateRange } : {}), // Merge date range
            },
            filterCount: filterDetails.filterCount,
            rawFilters: filterDetails.rawFilters,
            searchText: filterDetails.searchText,
        }),
        [filterDetails, dateRange]
    );

    const customCellRender = {
        momentum_last_year: (row) => {
            return (
                <TrendButton
                    title={row.client_name}
                    trending={row.momentum_last_year}
                    apiData={row.quarterly_momentum}
                    type="momentum"
                />
            );
        },
        market_share_momentum: (row) => {
            return (
                <TrendButton
                    title={row.client_name}
                    trending={row.market_share_momentum}
                    apiData={row.quarterly_market_share_momentum}
                    type="marketShare"
                />
            );
        },
        client_ca_total: (row) => {
            return <CorporateAccessTooltip data={row.client_ca_result || {}} />;
        },
        delta: (row) => {
            return <ValueBox value={row.delta} />;
        },
        aum: (row) => {
            return <CustomCurrencyFormat value={row.aum} />;
        },
        client_volume: (row) => {
            return <CustomCurrencyFormat value={row.client_volume} />;
        },
        ambit_volume: (row) => {
            return <CustomCurrencyFormat value={row.ambit_volume} />;
        },
        efforts_to_revenue: (row) => {
            return <WholeNumberFormatter value={row.efforts_to_revenue} keepDecimals={true} />;
        },
        overall_revenue_qoq_growth: (row) => {
            return <WholeNumberFormatter value={row.overall_revenue_qoq_growth} />;
        },
        yoy_revenue_growth: (row) => {
            return <WholeNumberFormatter value={row.yoy_revenue_growth} />;
        },
        qoq_budget_growth: (row) => {
            return <WholeNumberFormatter value={row.qoq_budget_growth} />;
        },
        yoy_budget_growth: (row) => {
            return <WholeNumberFormatter value={row.yoy_budget_growth} />;
        },
        service_intensity: (row) => {
            return <WholeNumberFormatter value={row.service_intensity} />;
        },
        last_financial_year_budget: (row) => {
            return <WholeNumberFormatter value={row.last_financial_year_budget} />;
        },
        current_financial_year_budget: (row) => {
            return <WholeNumberFormatter value={row.current_financial_year_budget} />;
        },
        ytd_revenue: (row) => {
            return <WholeNumberFormatter value={row.ytd_revenue} />;
        },
    };
    // const tierColorRender = (header, row) => {
    //     const keys = [
    //         'client_name',
    //         'rank',
    //         'client_tier',
    //     ];

    //     let styles = {};
    //     if (keys.includes(header.key)) {
    //         styles = {
    //             background: row.client_tier_color,
    //         }
    //     }
    //     return styles;
    // }
    return (
        <Layout>
            <div>
                <CommonNavigator />
                <div className="mt-2">
                    <CustomAdminLayout
                        title="Top 25 Client Performance"
                        showFilter={false}
                        filterCount={filterDetails.filterCount}
                        onFilterClick={() => toggleFilter(true)}
                        isNotAdmin
                        height="h-[calc(100vh-7rem)] min-h-[400px] overflow-auto"
                    >
                        <PaginatedDataTable
                            queryHook={useGetClientFinancialsQuery}
                            paginationEnabled={true}
                            showCheckboxColumn={false}
                            isHeaderBold={true}
                            appliedFilters={finalFilters.appliedFilters}
                            customCellRender={customCellRender}
                            initialDateRange={dateRange}
                            isColumnSticky={true}
                            stickyColumnsCount={3}
                            // headerFontSizes={["20px", "16px", "14px"]}
                            isClient={true}
                            // customCellColor={(header, row) => tierColorRender(header, row)}
                        />
                    </CustomAdminLayout>
                </div>
            </div>
        </Layout>
    );
};

export default SalesDashboard;
